<template id="">
  <div class="">
    <div class="md-layout">
      <div class="md-layout-item md-size-80 md-medium-size-100" v-if="step === 1">
        <md-card>
          <md-card-header>
            <h3>Add Your Company</h3>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label>Company Name</label>
              <md-input v-model="possibleCompany" required type="text"></md-input>
            </md-field>
          </md-card-content>
          <md-card-actions>
            <md-button v-on:click="checkCompany" class="md-info">Add Company</md-button>
          </md-card-actions>
        </md-card>
      </div>
        <div class="md-layout-item md-size-80 md-medium-size-100" v-else-if="step === 2">
          <md-card>
            <md-card-header>
              <h3>Add Your Company</h3>
            </md-card-header>
            <md-card-content>
              {{possibleCompany}} has already been created. Please contact your employer to be added to your company's account.
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-80 md-medium-size-100 start-project" v-else-if="step === 3">
          <md-card>
            <md-card-header>
              <h3>Add Your Company</h3>
            </md-card-header>
            <md-card-content class="content-inputs">
              <div class="md-layout start-inputs">
                <md-field class="md-layout-item md-size-100">
                  <label>Company Name</label>
                  <md-input v-model="newCompany.company_name" required type="text"></md-input>
                </md-field>
                <AutoCompleteInput
                  v-on:childToParent="onChildClick"
                  v-bind:company="true"
                />

                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Second Street Address</label>
                  <md-input v-model="newCompany.address_attributes.address_line_2" type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company City</label>
                  <md-input v-model="newCompany.address_attributes.city" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company State</label>
                  <md-input v-model="newCompany.address_attributes.state" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Zip Code</label>
                  <md-input v-model="newCompany.address_attributes.zip_code" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Office Phone</label>
                  <md-input v-model="newCompany.office_phone" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Email</label>
                  <md-input v-model="newCompany.company_email_address" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Contact Name</label>
                  <md-input v-model="newCompany.company_contact" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Contact Cell Phone Number</label>
                  <md-input v-model="newCompany.company_contact_number" required type="text"></md-input>
                </md-field>
              </div>
            </md-card-content>
            <md-card-actions>
              <md-button class="md-success" v-on:click="addCompany">Add Your Company</md-button>
            </md-card-actions>
          </md-card>
        </div>
      </div>
  </div>
</template>
<script>
  import api from '@/api';
  import AutoCompleteInput from '@/pages/Dashboard/ProjectPages/Components/AutoCompleteInput.vue';
  export default {
    created() {
      api.getCompanies().then((response) => {
        console.log(response);
        var companies = response.data.companies.map((c) => c.company.company_name)
        console.log(companies);
        this.exisitingCompanies = companies;
      })
    },
    components: {
      AutoCompleteInput
    },
    data() {
      return {
        step: 1,
        possibleCompany: '',
        exisitingCompanies: '',
        newCompany: {
          company_name: '',
          address_attributes: {
            street_address: '',
            address_line_2: '',
            city: '',
            state: '',
            zip_code: '',
            country: 'United States'
          },
          company_contact: '',
          company_contact_number: '',
          company_contact_title: '',
          office_phone: '',
          company_email_address: ''
        }
      }
    },
    methods: {
      checkCompany() {
        if (this.possibleCompany) {
          //this will be api call eventually
          var match = this.exisitingCompanies.filter((name) => name == this.possibleCompany);
          if (match.length > 0) {
            console.log(match);
            this.step = 2;
          } else {
            this.step = 3;
            this.newCompany.company_name = this.possibleCompany;
          }
        }
      },
      addCompany() {
        //post to backend
        var reqObj = [
          this.$store.state.user.id,
          {"company": this.newCompany}
        ];

        this.$store.dispatch("addCompany", reqObj).then(() => {
          this.notifyVue(`Thank you for setting your company. ${this.newCompany.company_name} has been saved. Please finish settings up your account on the User Profile.`)
          this.$router.push("/user");
          window.location.reload()
        });
      },
      notifyVue(message) {
        this.$notify({
          timeout: 3500,
          message: message,
          icon: "done_all",
          horizontalAlign: "left",
          verticalAlign: "top",
          type: "success"
        });
      },
      onChildClick (value) {
        this.newCompany.address_attributes.street_address = value[0].long_name + ' ' + value[1].long_name;
        this.newCompany.address_attributes.city = value[3].long_name;
        this.newCompany.address_attributes.state = value[5].long_name;
        this.newCompany.address_attributes.zip_code = value[7].long_name;
      },
    }
  }
</script>
<style media="screen" lang="scss">

</style>
